import { useCallback, useMemo, useReducer } from 'react'

export type EditSectionState = 'view' | 'edit' | 'saving'

type Action = 'startEdit' | 'cancel' | 'startSave' | 'saveSuccess' | 'saveError'

function reducer(state: EditSectionState, action: Action): EditSectionState {
  switch (action) {
    case 'startEdit':
      return state === 'view' ? 'edit' : state
    case 'cancel':
      return state === 'edit' ? 'view' : state
    case 'startSave':
      return state === 'edit' ? 'saving' : state
    case 'saveSuccess':
      return 'view'
    case 'saveError':
      return state === 'saving' ? 'edit' : state
  }
}

export type UseEditSectionResult = Readonly<{
  state: EditSectionState
  startEdit: () => void
  cancel: () => void
  startSave: () => void
  saveSuccess: () => void
  saveError: () => void
}>

export function useEditSection(): UseEditSectionResult {
  const [state, dispatch] = useReducer(reducer, 'view')

  const startEdit = useCallback(() => dispatch('startEdit'), [])
  const cancel = useCallback(() => dispatch('cancel'), [])
  const startSave = useCallback(() => dispatch('startSave'), [])
  const saveSuccess = useCallback(() => dispatch('saveSuccess'), [])
  const saveError = useCallback(() => dispatch('saveError'), [])

  return useMemo(
    () => ({ state, startEdit, cancel, startSave, saveSuccess, saveError }),
    [state, startEdit, cancel, startSave, saveSuccess, saveError],
  )
}
